import React from "react";
import DriverContent from "../content/driverContent";
import Layout from "../layout/Layout";

const Driver = () => {
  return (
    <Layout>
      <DriverContent />
    </Layout>
  );
};

export default Driver;
